import React from 'react';
import PropTypes from 'prop-types';
import Styles from './index.module.css';

function TutorialCard({ title, img }) {
  return (
    <>
      <div
        className={Styles.titleText}
      >
        {title}
      </div>
      <div
        className={Styles.card}
      >
        <img src={img} alt={title} className={Styles.cardImg} />
      </div>
    </>
  );
}

TutorialCard.propTypes = {
  title: PropTypes.string,
  img: PropTypes.string,
};

TutorialCard.defaultProps = {
  title: '???     >',
  img: '',
};

export default TutorialCard;
